(function ($) {
  $('.online-price').hover(function () {
    $(this).siblings('.online-price-hover-content').show();
  }, function () {
    var that = $(this).siblings('.online-price-hover-content');

    setTimeout(function () {
      if (!that.is(':hover')) {
        that.fadeOut(300);
      }
    }, 250);
  });
  $('.online-price-hover-content').mouseleave(function () {
    $(this).fadeOut(300);
  });
})(jQuery);
